/**
 * 地図の状態
 */
const state = {
  // タイルスクリプトは1画面で一つしか地図を描画しない前提の仕様のため、
  // 地図オブジェクトはアプリケーション全体で一つだけとしています
  map: null,
  // ピンオブジェクトの配列
  pins: [],
  // /map画面で選択されているタブ spotSearchかfavoriteが入る
  selectedSpotTab: 'spotSearch'
};

export { state as default };
